import {Component, Input, OnInit} from '@angular/core';
import {SynapiItem} from "../../../models/Synapi/SynapiItem";
import {IsBookmarkPipe} from "../../../pipes/is-bookmark.pipe";
import {BookmarksService} from "../../../services/bookmarks.service";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'synapi-bookmark-toggle',
  standalone: true,
  imports: [
    IsBookmarkPipe, CommonModule
  ],
  templateUrl: './synapi-bookmark-toggle.component.html',
  styleUrl: './synapi-bookmark-toggle.component.scss',
  host: {ngSkipHydration: 'true'},
})
export class SynapiBookmarkToggleComponent implements OnInit{
  @Input() item : SynapiItem;
  isBookmark : boolean = false;

  constructor(public bookmarksService : BookmarksService) {
  }

  ngOnInit(){
    this.isBookmark = this.bookmarksService.has(this.item);
  }
  onBookmarkClick(){
    this.bookmarksService.toggle(this.item);
  }
}
